import { render, staticRenderFns } from "./noInFormItem.vue?vue&type=template&id=2396ab2f&scoped=true&"
import script from "./noInFormItem.vue?vue&type=script&lang=js&"
export * from "./noInFormItem.vue?vue&type=script&lang=js&"
import style0 from "./noInFormItem.vue?vue&type=style&index=0&id=2396ab2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2396ab2f",
  null
  
)

component.options.__file = "noInFormItem.vue"
export default component.exports